// Resolve `WS /v1/ephemeral` URL — parallel to web `deriveWsUrlFromApiBase`.

export interface DeriveEphemeralWsUrlOptions {
  /** Absolute API base, e.g. `https://openmls.ping.live`. */
  readonly apiBaseUrl?: string | undefined;
}

/**
 * Ephemeral-service WebSocket URL. Hosts pass `apiBaseUrl` from env when
 * known; otherwise same-origin (Vite proxy) or production default.
 */
export function deriveEphemeralWsUrl(options: DeriveEphemeralWsUrlOptions = {}): string {
  const raw = options.apiBaseUrl ?? '';
  if (raw.length > 0) {
    try {
      const u = new URL(raw);
      const proto = u.protocol === 'https:' ? 'wss:' : 'ws:';
      return `${proto}//${u.host}/v1/ephemeral`;
    } catch {
      // fall through
    }
  }
  if (typeof window !== 'undefined' && window.location) {
    const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    return `${proto}//${window.location.host}/v1/ephemeral`;
  }
  return 'wss://openmls.ping.live/v1/ephemeral';
}
